import React from 'react';

const RadioButton = ({ selected, onClick, label }) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex items-center gap-2 px-4 py-2 rounded-lg border-2 transition-all ${
      selected ? 'bg-gray-100 border-blue-500' : 'bg-gray-50 border-gray-300'
    }`}
  >
    <span
      className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
        selected ? 'border-blue-500' : 'border-gray-300'
      }`}
    >
      {selected && <span className="w-2 h-2 rounded-full bg-blue-500" />}
    </span>
    {label}
  </button>
);

export default RadioButton;
